import React, { useState } from 'react';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { TableInput } from '../../../../../../../components/common';
import { Checkbox } from '@mui/material';
import TableTextArea from '../../../../../../../components/common/tableinputs/TableTextArea';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const getTotal = (moduleData: any) => {
  return moduleData?.c1?.reduce((sum: any, curr: any) => {
    return sum + +curr.score;
  }, 0);
};
const TBody = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <tbody>
      {moduleData &&
        moduleData?.c1?.map((process: any, index: number) => (
          <>
            <tr>
              <td align="left" style={{ fontSize: '15px',minWidth: '51px' }}>
                {process?.s_no}
              </td>
              <th align="left" style={{ fontSize: '15px', minWidth: '200px' }}>
                {process?.look_At}
              </th>
              <th align="left" style={{ fontSize: '15px', minWidth: '200px' }}>
                {process?.look_for}
              </th>
              <td style={{ minWidth: '250px' }}>
                <TableInput
                  isView={isView}
                  name="score"
                  type="text"
                  value={process?.score}
                  onChange={(e: any) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td align="left">
                <TableTextArea
                  style={{ minWidth: '250px', width: '250px' }}
                  resize={'vertical'}
                  isView={isView}
                  name="observation"
                  type="text"
                  value={process.observation}
                  onChange={(e: any) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
            </tr>
          </>
        ))}
      {/* <tr style={{ height: '50px' }}>
        <th colSpan={3} style={{ fontSize: '20px' }}>
          Total Score : {getTotal(moduleData)} / 38
        </th>
        <td style={{ fontSize: '20px' }}>{getTotal(moduleData)}</td>
        <th style={{ fontSize: '20px' }}>Max. Score: 38</th>
      </tr> */}
    </tbody>
  );
};

export default TBody;
